var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"w-full text-center text-indianyellow p-4 pin-b",attrs:{"id":"footer"}},[_vm._v(" © Copyright "+_vm._s(_vm.year)+" | LudusCristaltec ")])
}
var staticRenderFns = []

export { render, staticRenderFns }